module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.linkUrl) ? _c('router-link', {
    staticClass: "fancy-button pop-onhover bg-gradient",
    style: ({
      'font-size': _vm.fontSize
    }),
    attrs: {
      "to": _vm.linkUrl
    }
  }, [_c('span', {
    style: (_vm.spanStyle)
  }, [_vm._t("default")], 2)]) : _c('a', {
    staticClass: "fancy-button pop-onhover bg-gradient",
    style: ({
      'font-size': _vm.fontSize
    }),
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('span', {
    style: (_vm.spanStyle)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-016cafe5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gradientBtn/GradientBtn.vue
// module id = 1250
// module chunks = 1